import api from './api';

// Packages
export const adminPackagesAPI = {
  getAll: () => api.get('/admin/packages'),
  create: (data) => api.post('/admin/packages', data),
  update: (id, data) => api.put(`/admin/packages/${id}`, data),
  delete: (id) => api.delete(`/admin/packages/${id}`),
};

// Courses
export const adminCoursesAPI = {
  getAll: () => api.get('/admin/courses'),
  create: (data) => api.post('/admin/courses', data),
  update: (id, data) => api.put(`/admin/courses/${id}`, data),
  delete: (id) => api.delete(`/admin/courses/${id}`),
  getLessons: (courseId) => api.get(`/admin/courses/${courseId}/lessons`),
};

// Lessons
export const adminLessonsAPI = {
  create: (data) => api.post('/admin/lessons', data),
  update: (id, data) => api.put(`/admin/lessons/${id}`, data),
  delete: (id) => api.delete(`/admin/lessons/${id}`),
};

// Users
export const adminUsersAPI = {
  getAll: () => api.get('/admin/users'),
  getOne: (id) => api.get(`/admin/users/${id}`),
  create: (data) => api.post('/admin/users', data),
  update: (id, data) => api.put(`/admin/users/${id}`, data),
  delete: (id) => api.delete(`/admin/users/${id}`),
  updatePackage: (userId, packageId) => api.put(`/admin/users/${userId}/package`, { package_id: packageId }),
};

// Stats
export const adminStatsAPI = {
  get: () => api.get('/admin/stats'),
};

// Email Templates
export const adminEmailTemplatesAPI = {
  getAll: () => api.get('/admin/email-templates'),
  getOne: (id) => api.get(`/admin/email-templates/${id}`),
  update: (id, data) => api.put(`/admin/email-templates/${id}`, data),
  sendTest: (id, testEmail) => api.post(`/admin/email-templates/${id}/test`, { testEmail }),
};
